import InvestStrategiesNew from './InvestStrategiesNew';

export default InvestStrategiesNew;
